import { type RefObject, useState } from 'react'
import useOnMount from '../../hooks/useOnMount'
import { lazyLoadManager } from '../../services/LazyLoadManager'
import { useStripe } from '@stripe/react-stripe-js'
import { useCheckout } from './CheckoutContext'
import CheckoutSheetDrawer from '../CheckoutSheet/CheckoutSheetDrawer'
import CancelPromoCodeDialog from '../CancelPromoCodeDialog/CancelPromoCodeDialog'
import CheckoutSheet from '../CheckoutSheet/CheckoutSheet'
import { type CompletingOrderHandle } from '../../pages/CompletingOrder/CompletingOrder'
import { useHandlePostRedirectPayment } from '../../pages/CompletingOrder/useHandlePostRedirectPayment'
import { type CreateOrderParams } from '../../services/OrderManager.types'

type CheckoutProps = {
  completingOrderRef: RefObject<CompletingOrderHandle | null>
  callCreateOrder: (params: Omit<CreateOrderParams, 'bagAnalytics'>) => void
  isCartFlow?: boolean
}

function Checkout({
  completingOrderRef,
  callCreateOrder,
  isCartFlow = false,
}: CheckoutProps) {
  const { isCheckoutOpen, closeCheckout, setDiscountId } = useCheckout()
  const stripe = useStripe()
  const [showCancelPromoCodeDialog, setShowCancelPromoCodeDialog] =
    useState(false)

  useHandlePostRedirectPayment(completingOrderRef)

  useOnMount(() => {
    lazyLoadManager.loadStripeIfNeeded()
  })

  const onCancelPromocode = () => {
    setDiscountId(null)
  }

  return (
    <>
      <CheckoutSheetDrawer
        open={isCheckoutOpen}
        dismiss={closeCheckout}
        callCreateOrder={callCreateOrder}
        checkoutSheetComponent={CheckoutSheet}
        stripe={stripe}
        validated
        openCancelPromoCodeDialog={() => setShowCancelPromoCodeDialog(true)}
        isCartFlow={isCartFlow}
      />
      <CancelPromoCodeDialog
        show={showCancelPromoCodeDialog}
        onDismiss={() => setShowCancelPromoCodeDialog(false)}
        onCancel={onCancelPromocode}
      />
    </>
  )
}

export default Checkout
